/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddFormulasRequestDto,
  ErrorResponse,
  FormulaResponseDto,
  GetFormulasInPrescriptionResponseDto,
  PaginatedMaterialsEntityResponseDto,
  PrescriptionOrderDetailDto,
} from '../models/index';
import {
    AddFormulasRequestDtoFromJSON,
    AddFormulasRequestDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    FormulaResponseDtoFromJSON,
    FormulaResponseDtoToJSON,
    GetFormulasInPrescriptionResponseDtoFromJSON,
    GetFormulasInPrescriptionResponseDtoToJSON,
    PaginatedMaterialsEntityResponseDtoFromJSON,
    PaginatedMaterialsEntityResponseDtoToJSON,
    PrescriptionOrderDetailDtoFromJSON,
    PrescriptionOrderDetailDtoToJSON,
} from '../models/index';

export interface AddFormulasToPrescriptionRequest {
    prescriptionId: string;
    addFormulasRequestDto: AddFormulasRequestDto;
}

export interface CreateSupplementProviderFormulaRequest {
    body: object;
}

export interface GetFormulasInPrescriptionRequest {
    prescriptionId: string;
}

export interface GetSupplementProviderFormulasRequest {
    page?: number;
    pageSize?: number;
    records?: number;
}

export interface GetSupplementProviderMaterialsRequest {
    page?: number;
    pageSize?: number;
    search?: string;
    query?: string;
}

export interface GetSupplementProviderOrderDetailRequest {
    prescriptionId: string;
    prescriptionOrderId: string;
}

export interface RemoveFormulaFromPrescriptionRequest {
    prescriptionId: string;
    formulaId: string;
}

/**
 * 
 */
export class SupplementProviderApi extends runtime.BaseAPI {

    /**
     * Adds formulas from Personalized Nutrients API to a prescription by creating a prescription order with external formula IDs
     * Add formulas to prescription
     */
    async addFormulasToPrescriptionRaw(requestParameters: AddFormulasToPrescriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['prescriptionId'] == null) {
            throw new runtime.RequiredError(
                'prescriptionId',
                'Required parameter "prescriptionId" was null or undefined when calling addFormulasToPrescription().'
            );
        }

        if (requestParameters['addFormulasRequestDto'] == null) {
            throw new runtime.RequiredError(
                'addFormulasRequestDto',
                'Required parameter "addFormulasRequestDto" was null or undefined when calling addFormulasToPrescription().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/providers/supplements/{prescriptionId}/formulas`.replace(`{${"prescriptionId"}}`, encodeURIComponent(String(requestParameters['prescriptionId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddFormulasRequestDtoToJSON(requestParameters['addFormulasRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Adds formulas from Personalized Nutrients API to a prescription by creating a prescription order with external formula IDs
     * Add formulas to prescription
     */
    async addFormulasToPrescription(requestParameters: AddFormulasToPrescriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.addFormulasToPrescriptionRaw(requestParameters, initOverrides);
    }

    /**
     * Creates a new formula in Personalized Nutrients 3rd party API
     * Create formula for supplement provider
     */
    async createSupplementProviderFormulaRaw(requestParameters: CreateSupplementProviderFormulaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormulaResponseDto>> {
        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling createSupplementProviderFormula().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/providers/supplements/formulas`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FormulaResponseDtoFromJSON(jsonValue));
    }

    /**
     * Creates a new formula in Personalized Nutrients 3rd party API
     * Create formula for supplement provider
     */
    async createSupplementProviderFormula(requestParameters: CreateSupplementProviderFormulaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormulaResponseDto> {
        const response = await this.createSupplementProviderFormulaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all formulas in a prescription from the Personalized Nutrients API
     * Get formulas in prescription
     */
    async getFormulasInPrescriptionRaw(requestParameters: GetFormulasInPrescriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetFormulasInPrescriptionResponseDto>> {
        if (requestParameters['prescriptionId'] == null) {
            throw new runtime.RequiredError(
                'prescriptionId',
                'Required parameter "prescriptionId" was null or undefined when calling getFormulasInPrescription().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/providers/supplements/{prescriptionId}/formulas`.replace(`{${"prescriptionId"}}`, encodeURIComponent(String(requestParameters['prescriptionId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetFormulasInPrescriptionResponseDtoFromJSON(jsonValue));
    }

    /**
     * Retrieves all formulas in a prescription from the Personalized Nutrients API
     * Get formulas in prescription
     */
    async getFormulasInPrescription(requestParameters: GetFormulasInPrescriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetFormulasInPrescriptionResponseDto> {
        const response = await this.getFormulasInPrescriptionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches formulas list from Personalized Nutrients 3rd party API
     * Get all formulas for supplement provider
     */
    async getSupplementProviderFormulasRaw(requestParameters: GetSupplementProviderFormulasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FormulaResponseDto>>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['records'] != null) {
            queryParameters['records'] = requestParameters['records'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/providers/supplements/formulas`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FormulaResponseDtoFromJSON));
    }

    /**
     * Fetches formulas list from Personalized Nutrients 3rd party API
     * Get all formulas for supplement provider
     */
    async getSupplementProviderFormulas(requestParameters: GetSupplementProviderFormulasRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FormulaResponseDto>> {
        const response = await this.getSupplementProviderFormulasRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches materials list from local database for supplement provider
     * Get all materials for supplement provider
     */
    async getSupplementProviderMaterialsRaw(requestParameters: GetSupplementProviderMaterialsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedMaterialsEntityResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/providers/supplements/materials`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedMaterialsEntityResponseDtoFromJSON(jsonValue));
    }

    /**
     * Fetches materials list from local database for supplement provider
     * Get all materials for supplement provider
     */
    async getSupplementProviderMaterials(requestParameters: GetSupplementProviderMaterialsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedMaterialsEntityResponseDto> {
        const response = await this.getSupplementProviderMaterialsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves order details from Personalized Nutrients API for a prescription order
     * Get order detail for supplement provider
     */
    async getSupplementProviderOrderDetailRaw(requestParameters: GetSupplementProviderOrderDetailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PrescriptionOrderDetailDto>> {
        if (requestParameters['prescriptionId'] == null) {
            throw new runtime.RequiredError(
                'prescriptionId',
                'Required parameter "prescriptionId" was null or undefined when calling getSupplementProviderOrderDetail().'
            );
        }

        if (requestParameters['prescriptionOrderId'] == null) {
            throw new runtime.RequiredError(
                'prescriptionOrderId',
                'Required parameter "prescriptionOrderId" was null or undefined when calling getSupplementProviderOrderDetail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/providers/supplements/{prescriptionId}/orders/{prescriptionOrderId}`.replace(`{${"prescriptionId"}}`, encodeURIComponent(String(requestParameters['prescriptionId']))).replace(`{${"prescriptionOrderId"}}`, encodeURIComponent(String(requestParameters['prescriptionOrderId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PrescriptionOrderDetailDtoFromJSON(jsonValue));
    }

    /**
     * Retrieves order details from Personalized Nutrients API for a prescription order
     * Get order detail for supplement provider
     */
    async getSupplementProviderOrderDetail(requestParameters: GetSupplementProviderOrderDetailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PrescriptionOrderDetailDto> {
        const response = await this.getSupplementProviderOrderDetailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Removes a formula from a prescription by updating the prescription order\'s external formula IDs
     * Remove formula from prescription
     */
    async removeFormulaFromPrescriptionRaw(requestParameters: RemoveFormulaFromPrescriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['prescriptionId'] == null) {
            throw new runtime.RequiredError(
                'prescriptionId',
                'Required parameter "prescriptionId" was null or undefined when calling removeFormulaFromPrescription().'
            );
        }

        if (requestParameters['formulaId'] == null) {
            throw new runtime.RequiredError(
                'formulaId',
                'Required parameter "formulaId" was null or undefined when calling removeFormulaFromPrescription().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/providers/supplements/{prescriptionId}/formulas/{formulaId}`.replace(`{${"prescriptionId"}}`, encodeURIComponent(String(requestParameters['prescriptionId']))).replace(`{${"formulaId"}}`, encodeURIComponent(String(requestParameters['formulaId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Removes a formula from a prescription by updating the prescription order\'s external formula IDs
     * Remove formula from prescription
     */
    async removeFormulaFromPrescription(requestParameters: RemoveFormulaFromPrescriptionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeFormulaFromPrescriptionRaw(requestParameters, initOverrides);
    }

}
